import React, { useState } from "react";
import cn from "classnames";
import classes from "./notifyGuest.module.scss";
import { getObjectValue } from '@utility/utills';
import { getTimeInHrsMins, convertedDate } from '@utility/fireboardUtil';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { LABEL } from '../../../../veriables';
import { ReactComponent as SelectedMark } from '@assets/images/Fireboard/SelectedMark.svg';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const messages = [
    "Your [order type] order at [location] is now ready[slotName]. Thank you.",
    "Your order from [location] is now on its way to [address].",
    "Your order at [location] for [pickup time] is waiting for you. Please contact the store at [phone] if you need assistance.",
    "Your contactless delivery has left [location] and should be there shortly.  Our driver will ring the doorbell at your address.",
    "Thank you for checking in! A Team Member will be out with your order shortly. Stay in your vehicle and call us if you haven't gotten your food in the next 5 minutes.",
    "Thank you for checking in! Your order is not quite ready yet, but a Team Member should be out to you shortly with an update.",
    "Can you please contact [location] about your order at [phone] ? Thank you.",
    "We have a question about your order at [location]. Please contact the store at [phone] as soon as you can.",
    "Your order at [location] is taking longer than expected. We apologize for the delay, please contact the store if you want to change your order.",
    "One of the items on your order from [location] is currently unavailable. Please contact the store at [phone] to select a different item. Thank you.",
    "We are having trouble locating [address]. Please contact the store as soon as possible at [phone] so we can deliver your order.",
];


const renderCustomMessage = (sms, selectedCheck, storeInfo, currency) => {
    const { description: customDesciption, message: customMessage } = sms || {};
    let message = '' + (customDesciption || customMessage || '');

    const { name: storeName, address1: storeAddress, city: storeCity } = storeInfo || {};
    const { checkNumber, unpaidAmount, orders, businessDate, slotName } = selectedCheck || {};
    const { orderDate, pickupDate, checkInNote, address1: deliveryAddress, city: deliveryCity } =
        Array.isArray(orders) && orders.length > 0 ? orders[0] : {};

    let orderTimeInHrsMins = getTimeInHrsMins(orderDate);
    let pickupTimeInHrsMins = getTimeInHrsMins(pickupDate);

    const dataObject = {
        StoreName: storeName,
        StoreAddress: storeAddress,
        StoreCity: storeCity,
        CheckNumber: checkNumber,
        BusinessDate: convertedDate(businessDate),
        UnpaidAmount: `${currency}${unpaidAmount}`,
        OrderDate: convertedDate(orderDate),
        PickupDate: pickupDate ? convertedDate(pickupDate) : convertedDate(orderDate),
        PickupTime: pickupTimeInHrsMins || orderTimeInHrsMins,
        DeliverTo: checkInNote,
        DeliveryAddress: deliveryAddress,
        DeliveryCity: deliveryCity,
        CubbySlotName: slotName,
    };

    Object.entries(dataObject).forEach(([key, value]) => {
        message = message.replaceAll(`{{${key}}}`, value || '--');
    });

    return message;
};


const renderStandardMessage = (sms, filteredCheck, storeInfo) => {
    const getSourceTypeFromOrderType = (type) => {
        switch (type) {
            case 5: return "curbside";
            case 6: return "online";
            case 8: return "call in";
            case 7: return "walkup";
            default: return "";
        }
    };

    const dataObj = {
        address: filteredCheck?.checkInNote,
        phone: getFormatedPhoneNumber(storeInfo.phoneNumber),
        "pickup time": getTimeInHrsMins(filteredCheck?.pickupDate),
        location: storeInfo?.name,
        "order type": getSourceTypeFromOrderType(filteredCheck?.sourceType),
        "slotName": filteredCheck?.slotName,
    };

    let formatted = sms;

    Object.keys(dataObj).forEach((key) => {
        if (key === "address") {
            if (formatted.includes("Your order from [location] is now on its way to")) {
                const address = dataObj[key] || "";
                const replaceableText = !!address ? `[${key}]` : `to [${key}]`;
                formatted = formatted.replace(replaceableText, address);
            } else {
                formatted = formatted.replace(`[${key}]`, dataObj[key] || "your address");
            }
        } else if (key === 'slotName' && dataObj[key]) {
            formatted = formatted.replace(`[${key}]`, ` in cubby slot ${dataObj[key]}`);
        } else {
            formatted = formatted.replace(`[${key}]`, dataObj[key] || "");
        }
    });

    return formatted;
};

const SmsRow = ({ message, smsIndex, onClick, isSelected }) => {

    return (
        <div
            className={cn({ [classes.smsView]: true, [classes.highligthtedAction]: isSelected, }, 'row mx-0 p-2')}
            onClick={onClick}
        >
            <span className="w-95 pl-1 pr-0">
                {message}
            </span>
            {isSelected && <div className={cn(classes.SelectedMark, 'w-5 pl-0 pr-1 d-flex justify-content-end align-items-center text-right')}><SelectedMark /></div>}
        </div>
    );
};


const NotifyGuest = (props) => {
    const { selectedCheck, onHandleSendSms, onClose, customSmsList, filteredCheck } = props;
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [selectedSms, setSelectedSms] = useState(null);

    const currency = LABEL().CURRENCY_SYMBOL;
    const storeInfo = getObjectValue(() =>
        JSON.parse(window.sessionStorage.getItem('auth'), false)
    );
    let message = '';


    const smsList = [
        ...(Array.isArray(customSmsList) ? customSmsList.map((msg) => ({ type: 'custom', value: msg })) : []),
        ...messages.map((msg) => ({ type: 'standard', value: msg })),
    ];

    return (
        <div className="h-100 col-12 px-0 position-relative">
            <div className={cn(classes.headingTxt, 'pb-3 pt-2 fw-600')}>{FLABEL().NOTIFY_CUSTOM_STANDARD_MESSAGES}</div>
            <div className={cn(classes.smsList, 'h-80 overflowY')}>
                {smsList.map((item, index) => {

                    if (item.type === 'custom') {
                        message = renderCustomMessage(item.value, selectedCheck, storeInfo, currency);
                    } else {
                        message = renderStandardMessage(item.value, filteredCheck, storeInfo);
                    }

                    return (
                        <SmsRow
                            key={index}
                            message={message}
                            smsIndex={index}
                            isSelected={selectedIndex === index}
                            onClick={() => {
                                setSelectedIndex(selectedIndex === index ? null : index);
                                setSelectedSms(item)
                            }}
                        />
                    );
                })}
            </div>
            <div className="col-12 px-0 position-absolute fixed-bottom d-flex justify-content-end align-items-center fw-500">
                <div className={cn('w-20 p-3 d-flex align-items-center justify-content-center mr-4', classes.closeBtn)} onClick={() => onClose('close')}>
                    {FLABEL().NOTIFY_CANCEL}
                </div>
                <div className={cn('w-20 p-3 d-flex align-items-center justify-content-center', classes.SubmitBtn, { [classes.disabled]: selectedIndex === null })}
                    onClick={() => selectedIndex !== null && onHandleSendSms(message, { selectedSms }, filteredCheck)}
                >
                    {FLABEL().NOTIFY_SUBMIT}
                </div>
            </div>
        </div>
    );
};

export default NotifyGuest;
